import React from 'react';
import MkPill from '../MkPill';

const ANDROID = [
  'Choose the apps you want to pause.',
  "Switch on Accessibility for Bring Me Back when asked — it's how the app knows a chosen app has opened.",
  "That's it: pauses happen automatically.",
];

const IPHONE = [
  'Choose the apps you want to pause.',
  "In Apple's Shortcuts app, create a personal automation for each app: App → Is Opened → Run Immediately → \"Trigger Pause Check\".",
  'Bring Me Back shows the pause; "Continue to App" takes you back in.',
];

const Steps = ({ items }) => (
  <ol className="list-reset mk-setup__steps">
    {items.map((t, i) => (
      <li key={t}>
        <span className="mk-setup__n" aria-hidden="true">
          {i + 1}
        </span>
        <span>{t}</span>
      </li>
    ))}
  </ol>
);

// B7 — what setup really takes on each phone. On iOS the iPhone card comes first.
const BmbSetup = ({ platform }) => (
  <section
    className={`mk-setup section${platform === 'ios' ? ' mk-setup--ios' : ''}`}
    id="setup"
    aria-labelledby="mk-setup-title"
  >
    <div className="container-sm">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <h2 id="mk-setup-title" className="mk-h2">
            Setting it up, honestly
          </h2>
          <p className="mk-lead">What to expect on each phone.</p>
        </div>
        <div className="mk-setup__grid">
          <div className="mk-setup__col mk-setup__col--android reveal-from-bottom" data-reveal-delay="0">
            <div className="mk-card mk-setup__card">
              <p className="mk-setup__pill">
                <MkPill variant="platform">Android</MkPill>
              </p>
              <Steps items={ANDROID} />
            </div>
          </div>
          <div className="mk-setup__col mk-setup__col--iphone reveal-from-bottom" data-reveal-delay="120">
            <div className="mk-card mk-setup__card">
              <p className="mk-setup__pill">
                <MkPill variant="platform">iPhone</MkPill>
              </p>
              <Steps items={IPHONE} />
              <p className="mk-micro mk-setup__micro">
                The app walks you through each step. If Shortcuts isn't on your iPhone, you can get it from the App Store.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default BmbSetup;
